import { render, staticRenderFns } from "./group_edit.vue?vue&type=template&id=67eda74e&scoped=true&"
import script from "./group_edit.vue?vue&type=script&lang=js&"
export * from "./group_edit.vue?vue&type=script&lang=js&"
import style0 from "./group_edit.vue?vue&type=style&index=0&id=67eda74e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eda74e",
  null
  
)

export default component.exports